import { render } from "./OrderFail.vue?vue&type=template&id=0e3825c5"
import script from "./OrderFail.vue?vue&type=script&lang=js"
export * from "./OrderFail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__